import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

export const StyledReadOnlyTargetingDropdown = styled(Box)`
  border-top: 1px solid ${({ theme }) => theme.palette.divider};
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
  background-color: ${({ theme }) => theme.palette.background.boxLight};
  margin: ${({ theme }) => theme.spacing(0, -3)};
  padding: ${({ theme }) => theme.spacing(0, 3, 1, 3)};

  .targeting-dropdown-section:first-of-type{
    padding-top: ${({ theme }) => theme.spacing(3)};
  }

  .targeting-dropdown-section:last-of-type{
    padding-bottom: ${({ theme }) => theme.spacing(2)};
  }
`;
